export default "__VITE_ASSET__CoeBjvi3__"